<span class="spinner-wrapper"
      *ngIf="isLoading">
  <img [src]="src"
       class="spin"
       alt="Spinner"
       [class.small]="small"
       [class.medium]="medium"
       [class.large]="large" />
</span>
